import deburr from "lodash/deburr";

export const slugifyOrgName = (orgName: string): string =>
  deburr(orgName.toLowerCase()).trim().replace(/\W+/g, "-");
